
import { initializeApp } from 'firebase/app';

export const environment = {
  production: true,
  firebaseConfigReto: {
    apiKey: "AIzaSyAZkNzGklv8ro9S-S9qa1vTABK6yez8QXk",
    authDomain: "alo-fitosanitarios-reto.firebaseapp.com",
    projectId: "alo-fitosanitarios-reto",
    storageBucket: "alo-fitosanitarios-reto.appspot.com",
    messagingSenderId: "261245392187",
    appId: "1:261245392187:web:c80f4454057a347149d31e",
    measurementId: "G-0X7W22P4JJ"
  },
};

const app = initializeApp(environment.firebaseConfigReto);


console.log = function () { };
console.group = function () { };
console.table = function () { };
